import { useNavigate } from 'react-router-dom';
import { useAuthenticator, Button } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';

import styled from 'styled-components';

export const LoginLogoutButtonWithStyle = styled(Button)`
  align-items: center;
  border-color: white;
  border-radius: 0px;
  color: white;
  font-weight: 500;
  text-transform: none;

  &:hover {
      background-color: white;
      border-color: white;
      color: black;
  }
`;



const LogoutButton = () => {

    const { route } = useAuthenticator((context) => [
      context.route,
      context.signOut,
    ]);
    
    const navigate = useNavigate();
    async function logOutCustom() {
        try {
            
            await Auth.signOut(); // Clears session and cookies
            navigate('/'); // Redirect to home or login page
            setTimeout(() => {
                window.location.reload(); // Ensure the app state resets
            }, 100);
        } catch (error) {
            console.error("Error during sign out:", error);
        }
    }

    // function logOut() {
      // signOut();
      // navigate('/');
    // }
  
    return (
      <>
    {route !== "authenticated" ? (
      // <NavBtnLink
      //   onClick={() => navigate("/")}
      //   className="button border with-icon"
      // >
      //   Sign In as a Producer
      // </NavBtnLink>
      <br />
      // <Button onClick={() => navigate("/")}>Login</Button>
    ) : (
      <LoginLogoutButtonWithStyle onClick={() => logOutCustom()}>Esci</LoginLogoutButtonWithStyle>
      // <NavBtnLink
      //   onClick={() => logOut()}
      //   className="button border with-icon"
      // >
      //   Logout
      // </NavBtnLink>
    )}
  
    {/* <NavLink to="https://www.merum.club/" activeStyle>
      About us
    </NavLink> */}
    </>
  );
  };
  
export default LogoutButton;